import { simpleSort } from '../../common/utils/utils';

export const defaultConfirmStockLevelsSort = 'machinePositionAsc';

export const sortPickListItems = (sortMethod, items) => {

	const sortedItems = [...items];

	if (sortMethod === 'quantityAsc') {
		sortedItems.sort(simpleSort('quantity', 'asc'));
	}
	else if (sortMethod === 'quantityDsc') {
		sortedItems.sort(simpleSort('quantity', 'dsc'));
	}
	else if (sortMethod === 'alphabeticalAsc') {
		sortedItems.sort(simpleSort('productName', 'asc'));
	}
	else if (sortMethod === 'alphabeticalDsc') {
		sortedItems.sort(simpleSort('productName', 'dsc'));
	}
	else if (sortMethod === 'machinePositionAsc') {
		sortedItems.sort(simpleSort('position', 'asc'));
	}
	else if (sortMethod === 'machinePositionDsc') {
		sortedItems.sort(simpleSort('position', 'dsc'));
	}
	else if (sortMethod === 'pickOrderAsc') {
		sortedItems.sort(simpleSort('pickOrder', 'asc'));
	}
	else if (sortMethod === 'pickOrderDsc') {
		sortedItems.sort(simpleSort('pickOrder', 'dsc'));
	}
	// sort by position asc if sort method not set
	else {
		sortedItems.sort((a, b) => (100 * a.row + a.column) - (100 * b.row + b.column));
	}

	return sortedItems;
};

export const pickListSummarySortOptions = [
	{ label: 'Quantity: asc', value: 'quantityAsc' },
	{ label: 'Quantity: dsc', value: 'quantityDsc' },
	{ label: 'Alphabetical: asc', value: 'alphabeticalAsc' },
	{ label: 'Alphabetical: dsc', value: 'alphabeticalDsc' },
	{ label: 'Position: asc', value: 'machinePositionAsc' },
	{ label: 'Position: dsc', value: 'machinePositionDsc' },
	{ label: 'Pick order: asc', value: 'pickOrderAsc' },
	{ label: 'Pick order: dsc', value: 'pickOrderDsc' },
];

export const confirmStockLevelsSortOptions = [
	{ label: 'Quantity: asc', value: 'quantityAsc' },
	{ label: 'Quantity: dsc', value: 'quantityDsc' },
	{ label: 'Alphabetical: asc', value: 'alphabeticalAsc' },
	{ label: 'Alphabetical: dsc', value: 'alphabeticalDsc' },
	{ label: 'Position: asc', value: defaultConfirmStockLevelsSort },
	{ label: 'Position: dsc', value: 'machinePositionDsc' },
];
